<div class="documents-dialog" *ngIf="active">
  <div class="documents-dialog__content">
    <button class="documents-dialog__content__close" (click)="closeDialog()">
      <span class="material-icons">close</span>Close
    </button>
    <h2>Preferred Site Visit Dates Submitted</h2>
    <ng-container>
      <div class="">
        <div class="mb-10">
          Your preferred site visit dates have been submitted and are currently
          under review. We'll be in touch shortly to confirm the scheduled date.
        </div>
        <br />
        <br />
        <div class="panelfields mt-30">
          <button
            type="submit"
            class="btn-site-visit w-15"
            (click)="closeDialog()"
          >
            Close
          </button>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="documents-dialog__background" (click)="closeDialog()"></div>
</div>
